module.exports = __webpack_public_path__ + "static/media/qty-decimal-point-4-preview.401543ec.png";